"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jkRoomsCountSelectorOptions = exports.ALL = void 0;
var _getNewbuildingEstimationWeb = require("../repositories/newbuilding-estimate/v1/get-newbuilding-estimation-web");
/**
 * Набор опций для селектора комнатности ЖК состоит из всех значений ERoomCount из апи
 * и дополнительно кнопки "Все"
 * */
const ALL = exports.ALL = 'All';
const jkRoomsCountSelectorOptions = exports.jkRoomsCountSelectorOptions = {
  [ALL]: {
    label: 'Все',
    selectedLabel: 'Любая комнатность',
    value: ALL
  },
  [_getNewbuildingEstimationWeb.ERoomCount.Studio]: {
    label: 'Студия',
    selectedLabel: 'Студия',
    value: _getNewbuildingEstimationWeb.ERoomCount.Studio
  },
  [_getNewbuildingEstimationWeb.ERoomCount.OneRoom]: {
    label: '1',
    selectedLabel: '1 комн.',
    value: _getNewbuildingEstimationWeb.ERoomCount.OneRoom
  },
  [_getNewbuildingEstimationWeb.ERoomCount.TwoRoom]: {
    label: '2',
    selectedLabel: '2 комн.',
    value: _getNewbuildingEstimationWeb.ERoomCount.TwoRoom
  },
  [_getNewbuildingEstimationWeb.ERoomCount.ThreeRoom]: {
    label: '3',
    selectedLabel: '3 комн.',
    value: _getNewbuildingEstimationWeb.ERoomCount.ThreeRoom
  },
  [_getNewbuildingEstimationWeb.ERoomCount.FourRoom]: {
    label: '4+',
    selectedLabel: '4+ комн.',
    value: _getNewbuildingEstimationWeb.ERoomCount.FourRoom
  }
};